/**
 * Codmon SearchFieldディレクティブ
 *
 * @description
 * このディレクティブは、検索用の入力フィールドを提供します。
 * 検索アイコン、クリアボタン、ラベル、サポートテキストなどをカスタマイズ可能です。
 *
 * @example
 * // 基本的な使い方（ラベル付き）
 * <codmon-search-field
 *   ng-model="searchText"
 *   label="検索"
 *   placeholder="キーワードを入力">
 * </codmon-search-field>
 *
 * @example
 * // ラベルなし
 * <codmon-search-field
 *   ng-model="searchText"
 *   placeholder="検索">
 * </codmon-search-field>
 *
 * @example
 * // サポートテキスト付き
 * <codmon-search-field
 *   ng-model="searchText"
 *   label="検索"
 *   placeholder="キーワードを入力"
 *   support-text="絞り込み：テキスト">
 * </codmon-search-field>
 *
 * @property {string} [label] - ラベルテキスト
 * @property {string} [placeholder] - プレースホルダーテキスト
 * @property {string} [supportText] - サポートテキスト
 * @property {boolean} [ngDisabled=false] - 無効化状態
 * @property {string} [name] - input要素のname属性
 * @property {function} [onClear] - クリアボタンクリック時のコールバック関数
 */
angular.module('inspinia').directive('codmonSearchField', () => {
  return {
    restrict: 'E',
    scope: {
      label: '@',
      placeholder: '@',
      supportText: '@',
      ngDisabled: '=?',
      name: '@',
      testId: '@',
      ngModel: '=',
      onClear: '&?',
    },
    templateUrl: `/manage/src/view/directive/codmon-ui/codmon_search_field.html?${new Date().getTime()}`,
    link($scope, _element, _attrs) {
      // ユニークなIDを生成
      $scope.inputId = `codmon-search-field-${$scope.$id}`;
      $scope.supportTextId = `codmon-search-field-support-${$scope.$id}`;

      // デフォルト値の設定
      $scope.ngDisabled = !!$scope.ngDisabled;

      // 値があるかどうか
      $scope.hasValue = () => {
        return !!$scope.ngModel;
      };

      // aria-describedbyの値を計算
      $scope.getAriaDescribedBy = () => {
        if ($scope.supportText) {
          return $scope.supportTextId;
        }
        return undefined;
      };

      // クリアボタンのクリック
      $scope.clearInput = () => {
        $scope.ngModel = '';
        if ($scope.onClear) {
          $scope.onClear();
        }
        // フォーカスを戻す
        const inputEl = _element[0].querySelector('input');
        if (inputEl) {
          inputEl.focus();
        }
      };

      // コンテナのクラス
      $scope.containerClasses = () => {
        return {
          'codmon-search-field': true,
        };
      };

      // 入力ラッパーのクラス
      $scope.inputWrapperClasses = () => {
        return {
          'codmon-search-field__wrapper': true,
          'codmon-search-field__wrapper--disabled': $scope.ngDisabled,
        };
      };
    },
  };
});
